<template>
  <div>
    <el-tabs type="border-card" class="fullHeight" @tab-click="clickTab">
      <el-tab-pane class="paddingBody" :label="$t('Tareas')">
        <center v-if="hidden === false">
          <el-alert type="info">
            <el-progress :status="step_percentage === 100 ? 'success' : null" :percentage="step_percentage"
              style="margin-bottom: 5px;"></el-progress>
            <small style="font-size: 15px;">{{ step_loading_txt }}</small>
          </el-alert>
          <br><br>
        </center>
        <center v-if="loadingAllDataRequired">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px;"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <div v-else class="content">
          <CompShowPage v-if="contract && inventory && Object.keys(inventory).length > 0" :workflows="workflows"
            :inventory="inventory" :contractPeople="contractPeople" :contract="contract" />
          <div v-if="contract !== null && inventory !== null && Object.keys(inventory).length === 0"
            class="red no-inventory">
            {{ $t('Inventario de Riesgos') }}
            <b>{{ $t('NO INICIADO') }}</b>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane class="paddingBody" :label="$t('Contrato')">
        <MostrarContrato v-if="contract" :contract="contract" />
      </el-tab-pane>
      <el-tab-pane label="Seguimiento" class="paddingBody">
        <center v-if="loading_seguimiento">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px;"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <el-table v-else :data="seguimiento" style="width: 100%" height="600"
          empty-text="No se han encontrado datos de seguimiento"
          header-cell-class-name="header-cell-class-table-gray">
          <el-table-column width="110">
            <template slot-scope="scope">
              <img v-if="scope.row.type === 'add'" src="../../assets/icons/add.png" width="30" />
              <img v-if="scope.row.type === 'delete'" src="../../assets/icons/delete.png" width="30" />
              <img v-if="scope.row.type === 'update'" src="../../assets/icons/update.png" width="30" />
            </template>
          </el-table-column>
          <el-table-column width="260" prop="user" label="Nombre"></el-table-column>
          <el-table-column width="260" label="Fecha">
            <template slot-scope="scope">{{ scope.row.date | moment("DD/MM/YYYY hh:mm:ss") }}</template>
          </el-table-column>
          <el-table-column prop="action" label="Acción"></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane v-if="inventory && inventory.motivos" class="paddingBody content" :label="$t('Motivos cambios a borrador')">
        <el-table
          :data="inventory.motivos"
          style="width: 100%;" header-cell-class-name="header-cell-class-table-gray">
          <el-table-column width="400" prop="fecha" label="Fecha">
            <template slot-scope="scope">
              {{ scope.row.fecha | moment("LLLL") }}
            </template>
          </el-table-column>
          <el-table-column prop="motivo" label="Motivo">
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane v-if="inventory" @tab-click="clickTab" class="paddingBody content" :label="$t('Comentarios')">
        <el-button
          v-if="!loadingComentarios && !['coordinator', 'contractor_coordinator'].includes($store.getters.role.role) && !$store.getters.user.readonly"
          @click="addComentario = true;" type="primary" size="small">Agregar
          Comentario</el-button>
        <center v-if="loadingComentarios">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <el-table v-else :data="comentarios" style="width: 100%; margin-top: 20px;"
          header-cell-class-name="header-cell-class-table-gray">
          <el-table-column prop="nombre" label="Usuario">
          </el-table-column>
          <el-table-column prop="rol" label="Rol">
            <template slot-scope="scope">
              {{ reviewerRoles[scope.row.rol] }}
            </template>
          </el-table-column>
          <el-table-column prop="fecha" label="Fecha">
            <template slot-scope="scope">
              {{ getHumanDate(scope.row.fecha) }}
            </template>
          </el-table-column>
          <el-table-column prop="comentario" label="Comentario">
          </el-table-column>
          <el-table-column label="Opciones"
            v-if="!['coordinator', 'contractor_coordinator'].includes($store.getters.role.role) && !$store.getters.user.readonly">
            <template slot-scope="scope">
              <el-button v-if="scope.row.id_usuario === $store.getters.user._id || this.role.admin === true"
                @click="deleteComentario(scope.row._id)" type="danger" size="small">Eliminar</el-button>
              <el-button v-if="scope.row.id_usuario === $store.getters.user._id || this.role.admin === true"
                @click="openEditComentario(scope.row)" type="info" size="small">Editar</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="Agregar Comentario" :visible.sync="addComentario" width="30%" :before-close="handleClose">
      <el-form>
        <el-form-item label="Ingrese su comentario">
          <el-input type="textarea" :rows="3" :placeholder="$t('Ingrese sus comentarios')" v-model="comentario.comentario"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
        <el-button type="primary" @click="addComentarioBD">Confirmar</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Editar Comentario" :visible.sync="editComentario" width="30%" :before-close="handleClose">
      <el-form>
        <el-form-item label="Ingrese su comentario">
          <el-input type="textarea" :rows="3" :placeholder="$t('Ingrese sus comentarios')" v-model="comentario.comentario"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
        <el-button type="primary" @click="actualizarComentario">Confirmar</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { Circle9 } from "vue-loading-spinner";
import { mapActions } from "vuex";
import moment from "moment";
import inventoryRequirements from "@/mixins/inventoryRequirements";
import CompShowPage from "@/components/C_ShowPage.vue";
import MostrarContrato from "@/components/MostrarContrato.vue";
import axios from "axios";

export default {
  mixins: [inventoryRequirements],
  components: {
    CompShowPage,
    MostrarContrato,
    Circle9
  },
  data() {
    return {
      loadingComentarios: false,
      reviewerRoles: {
        admin: "Administrador de Plataforma",
        health: "Especialista de Salud",
        safety: "Especialista de Seguridad",
        environment: "Especialista de Medioambiente",
        contractor_hse: "HSE Contratista",
        contract_owner: "Dueño de Contrato",
        administrator: "Administrador de Contrato",
        hse: "HSE",
        owner: "Dueño de Contrato",
        risk: "Especialista de Riesgo",
        manager: "Gerente",
        super: "Superintendente",
        general_manager: "Gerente General",
      },
      id_comentario: null,
      comentario: {
        comentario: "",
      },
      addComentario: false,
      editComentario: false,
      comentarios: [],
      seguimiento: [],
      loading_seguimiento: false,
      auxStatus: {
        0: { text: "Borrador", colorClass: "gray" },
        1: { text: "Revisión", colorClass: "yellow" },
        2: { text: "Aprobado", colorClass: "green" },
        3: { text: "Importado Borrador", colorClass: "gray" },
      },
    };
  },
  created() {
  },
  watch: {
    step_percentage(newVal, oldVal) {
      if (newVal === 100) {
        setTimeout(() => this.hidden = true, 1500);
      }
    },
    inventory(newVal, oldVal) {
      this.getSeguimiento(newVal._id);
    },
    contract: {
      handler() {
        if (this.contract && this.contract.nombre) {
          this.setSubTitle(`${this.contract.nombre}`);
        }
      },
    },
  },
  methods: {
    ...mapActions(["setSubTitle"]),
    handleClose() {
      this.comentario = {
        comentario: "",
      }
      this.id_comentario = null;
      this.editComentario = false;
      this.addComentario = false;
    },
    openEditComentario(comentario) {
      this.id_comentario = comentario._id;
      this.comentario.comentario = comentario.comentario;
      this.editComentario = true;
    },
    deleteComentario(_id) {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      this.$confirm(
        'Estás a punto de eliminar un comentario. ¿Deseas Continuar?',
        'Advertencia',
        {
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          type: 'warning',
        },
      )
        .then(async () => {
          await axios.post(`/inventarios/deleteComentarios`, {
            _id: _id
          }, config);
          this.getComentarios();
        })
        .catch(() => {
        });
    },
    getHumanDate(date) {
      return moment(date).format("DD MMMM YYYY HH:mm");
    },
    async actualizarComentario() {
      this.$confirm(
        'Estás a punto de actualizar un comentario. ¿Deseas Continuar?',
        'Advertencia',
        {
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          type: 'warning',
        },
      )
        .then(async () => {
          const config = {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          };
          if (this.comentario.comentario === "") {
            this.$notify({
              duration: 3000,
              title: "Atención",
              message: "Para continuar debes completar todos los campos",
              type: "Warning",
            });
          } else {
            await axios.post(`/inventarios/updateComentario`, {
              _id: this.id_comentario,
              comentario: this.comentario.comentario
            }, config);
            this.getComentarios();
            this.handleClose();
          }
        })
        .catch(() => {
        });
    },
    async addComentarioBD() {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      if (this.comentario.comentario === "") {
        this.$notify({
          duration: 3000,
          title: "Atención",
          message: "Para continuar debes completar todos los campos",
          type: "Warning",
        });
      } else {
        await axios.post(`/inventarios/addComentario`, {
          id_usuario: this.$store.getters.user._id,
          rol: this.$store.getters.role.role,
          id_inventario: this.inventory._id,
          nombre: `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`,
          comentario: this.comentario.comentario,
          fecha: new Date(),
          leido: false
        }, config);
        this.getComentarios();
        this.handleClose();
      }
    },
    async getComentarios() {
      this.loadingComentarios = true;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      let response = await axios.post(`/inventarios/getAllComentarios`, {
        id_inventario: this.inventory._id
      }, config);
      this.comentarios = response.data;
      this.loadingComentarios = false;
    },
    clickTab(tab) {
      if (tab.label === "Seguimiento") {
        this.getSeguimiento(this.inventory._id);
      }
      if (tab.label === "Comentarios") {
        this.getComentarios();
      }
    },
    goBack() {
      window.history.go(-1);
    },
    isActiveContract() {
      if (this.contract.tipo_contrato == "Propio") return true;
      return moment(this.contract.fecha_fin) - new Date() >= 0;
    },
    inventoryStatusText() {
      return this.inventory && this.inventory.status
        ? this.auxStatus[parseInt(this.inventory.status, 10)].text
        : "No Iniciado";
    },
    inventoryStatusColor() {
      return this.inventory && this.inventory.status
        ? this.auxStatus[parseInt(this.inventory.status, 10)].colorClass
        : "gray";
    },
    getSeguimiento(id) {
      this.loading_seguimiento = true;
      const self = this;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      axios
        .get(`/inventarios/getSeguimiento/${id}`, config)
        .then((response) => {
          self.seguimiento = response.data;
          self.loading_seguimiento = false;
        });
    },
  },
};
</script>

<style scoped>
.content {
  min-height: 50vh;
}

.no-inventory {
  padding: 20px;
  color: #ffffff;
  text-align: center;
}
</style>
